import { render, staticRenderFns } from "./PolicyWarning.vue?vue&type=template&id=3c32eeb2&scoped=true"
import script from "./PolicyWarning.vue?vue&type=script&lang=js"
export * from "./PolicyWarning.vue?vue&type=script&lang=js"
import style0 from "./PolicyWarning.vue?vue&type=style&index=0&id=3c32eeb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c32eeb2",
  null
  
)

export default component.exports